<template>
    <div class="aed-date-picker">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        persistent-hint
        prepend-icon="mdi-calendar"
        v-bind="field"
        @blur="updateDate"
        type="number"
        append-icon="mdi-close"
        @click:append="date = null"
      />
      <v-menu
        ref="menu1"
        v-model="menu1"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-bind="attrs" v-on="on" readonly />
        </template>
        <v-date-picker v-model="date" no-title />
      </v-menu>
    </div>
  </template>
  
  <script>
  import moment from 'moment'
  
  export default {
    name: 'aedDatePicker',
    props: {
      field: Object,
      label: String,
      value: String, // Initial date value (optional)
    },
    data() {
      return {
        date: null,
        dateFormatted: '',
        menu1: false,
      };
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.formattedDate = this.formatDate(newValue);
          this.date = moment(newValue, 'YYYY-MM-DD', true).isValid() ? newValue : null;
        } else {
          this.formattedDate = '';
          this.date = null;
        }
      },
    },
    methods: {
      updateDate() {
        const allowedFormats = ['DD.MM.YYYY', 'D.M.YYYY'];
        const regex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
  
        if (regex.test(this.dateFormatted)) {
          for (const format of allowedFormats) {
            if (moment(this.dateFormatted, format, true).isValid()) {
              this.date = moment(this.dateFormatted, format).format('YYYY-MM-DD');
              this.$emit('input', this.date); // Emit the date in YYYY-MM-DD format
              return;
            }
          }
        }
  
        // Invalid format
        this.date = null;
        this.formattedDate = '';
      },
      formatDate(date) {
        if (!date) return null;
        return moment(date).isValid() ? moment(date).format('DD.MM.YYYY') : null;
      },
    },
  };
  </script>
  
  <style scoped>
  .aed-date-picker {
    display: flex;
  }
  </style>
  